// extracted by mini-css-extract-plugin
export var menuItem = "w_tR d_fZ d_bz d_bD d_bP d_bf";
export var menuItemSub = "w_tS d_Z d_bz d_bP";
export var menuMainLink = "w_tT d_f0 d_dB";
export var menuLink = "w_tV d_f0 d_dB";
export var icon = "w_p9 d_bC d_bP";
export var divider = "w_tW d_bC d_bP";
export var sublinks = "w_tX";
export var link = "w_mC";
export var Link = "w_r7 s_r7 s_rs s_rN";